__turbopack_context__.v({
  "section": "SnapSections-module-scss-module__AAi2RG__section",
  "sectionSnapping": "SnapSections-module-scss-module__AAi2RG__sectionSnapping",
  "sections": "SnapSections-module-scss-module__AAi2RG__sections",
});
